<template>
    <footer class="footer" ref="container">
        <div class="footer__inner">
            <div class="footer__main">
                <div class="container">
                    <div class="row nowrap">
                        <div class="col footer__col footer__contacts">
                            <div class="footer__col-inner">
                                <div class="footer__title">{{params.footer__contacts.title}}</div>
                                <ul class="footer__menu">
                                  <li class="footer__menu-item " :class="item.url.indexOf('tel:')==(-1)?'footer__contacts-consult-btn':''" v-for="(item, i) in params.footer__contacts.items" :key="i">
                                    <a :href="item.url" class="footer__menu-link">{{ item.title }}</a>
                                  </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col footer__col" v-for="(col, i) in params.menu" :key="i">
                            <div class="footer__col-inner">
                                <a-expand>
                                    <template #header>
                                        <div class="footer__title">{{ col.title }}</div>
                                    </template>
                                    <template #body>
                                        <ul class="footer__menu">
                                            <li class="footer__menu-item" v-for="(item, i) in col.items" :key="i">
                                                <a :href="item.url" class="footer__menu-link">{{ item.title }}</a>
                                            </li>
                                        </ul>
                                    </template>
                                </a-expand>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer__bottom">
                <div class="container">
                    <div class="footer__bottom-inner">
                        <div class="row between v-center">
                            <div class="col d8 footer__bottom-col-left">
                                <div class="flex v-center wrap">
                                    <div class="footer__bottom-col">
                                        <span class="cpr">
<!--                                          © 2011—{{ currentYear }}-->
                                          <span class="cpr__sitename">"{{params.messages.companyName}}".</span>
                                          <span class="cpr__text">{{params.messages.paravaZasch}}</span>
                                        </span>
                                    </div>
                                    <div class="footer__bottom-col" v-if="params.privacy">
                                        <a :href="params.privacy.url">{{ params.privacy.title }}</a>
                                    </div>
                                    <div class="footer__bottom-col" >
                                        <div class="footer__langs dropdown" v-if="params.langs.length>0">
                                            <div class="dropdown__btn flex v-center">
                                                <svg class="icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11 22.0001C17.0654 22.0001 22 17.0655 22 11.0001C22 4.93467 17.0654 0 11 0C4.9346 0 0 4.93467 0 11.0001C0 17.0655 4.9346 22.0001 11 22.0001ZM3.82813 16.4309C4.69973 16.0881 5.79713 15.8149 7.0306 15.6277C7.19807 16.6331 7.42033 17.5652 7.69433 18.3874C7.83787 18.818 7.989 19.1981 8.14513 19.5357C6.4116 18.9544 4.91207 17.8588 3.82813 16.4309ZM2 11.0001C2 9.6838 2.28413 8.4326 2.79407 7.3046C3.8756 7.7676 5.2418 8.1258 6.78087 8.35707C6.70593 9.21113 6.66667 10.0973 6.66667 11.0001C6.66667 11.9029 6.70593 12.7891 6.78087 13.6431C5.2418 13.8745 3.87553 14.2327 2.79413 14.6957C2.28413 13.5677 2 12.3165 2 11.0001ZM11 2C11.2153 2 11.8429 2.54873 12.4084 4.2452C12.6408 4.94253 12.8319 5.7334 12.9794 6.58973C12.3365 6.63467 11.6736 6.6584 10.9997 6.6584C10.3261 6.6584 9.66333 6.63473 9.0206 6.58973C9.16807 5.7334 9.3592 4.9426 9.59167 4.24527C10.1571 2.54873 10.7847 2 11 2ZM10.9997 8.6584C11.7615 8.6584 12.5083 8.6304 13.2317 8.577C13.2985 9.35733 13.3333 10.1697 13.3333 11.0001C13.3333 11.8305 13.2985 12.6428 13.2317 13.4231C12.5084 13.3697 11.7617 13.3417 11 13.3417C10.2383 13.3417 9.4916 13.3697 8.76833 13.4231C8.70153 12.6428 8.66667 11.8305 8.66667 11.0001C8.66667 10.1697 8.70153 9.3574 8.76833 8.577C9.49153 8.6304 10.2381 8.6584 10.9997 8.6584ZM20 11.0001C20 12.3164 19.7159 13.5675 19.2059 14.6955C18.1244 14.2325 16.7582 13.8744 15.2191 13.6431C15.2941 12.7891 15.3333 11.903 15.3333 11.0001C15.3333 10.0972 15.2941 9.21107 15.2191 8.357C16.7582 8.12573 18.1244 7.76747 19.2058 7.3044C19.7159 8.43247 20 9.68373 20 11.0001ZM11 20.0001C10.7847 20.0001 10.1571 19.4513 9.59173 17.7549C9.35927 17.0575 9.16813 16.2667 9.0206 15.4104C9.66347 15.3654 10.3262 15.3417 11 15.3417C11.6738 15.3417 12.3366 15.3654 12.9794 15.4104C12.8319 16.2667 12.6408 17.0576 12.4084 17.7549C11.8429 19.4514 11.2154 20.0001 11 20.0001ZM13.855 19.5357C14.0111 19.1981 14.1622 18.818 14.3057 18.3874C14.5798 17.5652 14.8021 16.6331 14.9695 15.6277C16.2029 15.8149 17.3003 16.0881 18.1719 16.4309C17.088 17.8587 15.5885 18.9543 13.855 19.5357ZM18.1717 5.56913C17.3003 5.91193 16.2029 6.1852 14.9695 6.37233C14.802 5.367 14.5798 4.43487 14.3057 3.61273C14.1623 3.18213 14.0111 2.80207 13.8549 2.46433C15.5884 3.0458 17.0879 4.14133 18.1717 5.56913ZM8.14513 2.4644C7.989 2.802 7.83793 3.18213 7.69433 3.61273C7.42033 4.435 7.19807 5.36707 7.0306 6.37247C5.79713 6.18527 4.69973 5.91207 3.82813 5.56933C4.912 4.14147 6.41153 3.04573 8.14513 2.4644Z" fill="#D8DCDE"/>
                                                </svg>
                                                <span>{{currentlang.name}}</span>
                                            </div>
                                            <div class="dropdown__panel langs__dropdown">
                                                <div class="dropdown__panel-inner">
                                                    <template v-for="(item, i) in params.langs">
                                                        <a :href="item.url" class="dropdown__item langs__item" :key="i" v-if="!item.current">{{ item.title }}</a>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="footer__bottom-col footer__search-link" v-if="params.search">
                                        <a :href="params.search.url">{{ params.search.title }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col ">
                                          <a :href="params.aniart.url" class="footer__develop">
                                            <span class="develop-title">
                                              {{ params.aniart.title }}
                                            </span>
                                           <img class="social__icon" :src="params.aniart.icon" alt="">
                                          </a>
                            </div>
                            <div class="col ">
                                <ul class="footer__soc social">
                                    <li class="social__item" v-for="(item, i) in params.social" :key="i">
                                        <span :data-href="item.url" rel="nofollow" target="_blank" class="social__link hlink">
                                            <img class="social__icon" :src="item.icon" alt="">
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>

import { AExpand } from '../ui'
import {onMounted, ref} from "vue";

export default {
    name: 'AppFooter',
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        AExpand,

    },
    setup: (props, ctx) => {
        const container = ref(null);
        const currentYear = new Date().getFullYear();
        let lang = {};
        for (let index in props.params.langs) {
          if(props.params.langs[index].current) {
            lang = props.params.langs[index];
          }
        }
        const currentlang = lang;
      onMounted(() => {
        setTimeout(() => {
          window.replaceHLink(container.value);
        }, 800);
      });
        return {
          currentYear,
          container,
          currentlang
        }
    },
}
</script>

<style lang="scss">
    .footer {
        border-top: 1px solid var(--c-gray-700);
        margin-top: -1px;
        &__develop {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          text-decoration: none;
        }
        &__develop:hover{
          text-decoration: none;
        }
        &__develop .develop-title{
          margin-right: 16px;
        }
        &__develop img{
          width: 40px;
          height: 40px;
        }
        &__main {
            padding: 78px 0 68px 0;

            @include mobile {
                padding: 0;
                .container {
                    padding: 0;
                    > .row {
                        flex-wrap: wrap;
                        margin: 0;
                    }
                }
            }
        }
        &__col {
            width: 100%;
            @include tablet {
                width: 25%;
            }
            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6){
                width: 60%;

                @include tablet {
                    width: 25%;
                }
                @include mobile {
                    width: 100%;
                }
            }
            &:nth-child(5) {
                .footer__col-inner {
                    /*padding-left: 30%;*/

                    @include tablet {
                        padding-left: 0;
                    }
                }
            }

            @include mobile {
                width: 100%;
                padding: 15px;
                border-bottom: 1px solid var(--c-gray-700);
            }
        }
        &__title {
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: var(--c-gray-200);

            @include mobile {
                font-size: 14px;
                line-height: 20px;
            }
        }
        &__menu {
            list-style: none;
            margin: 0;
            padding: 30px 0 0 0;
            @include mobile {
                padding: 17px 0 0 0;
            }

            &-item {
                margin-bottom: 23px;
                font-size: 14px;
                &:last-child {
                    margin-bottom: 0;
                }

                @include tablet {
                    font-size: 12px;
                }
            }
            &-link {
                color: var(--c-gray-400);
            }
        }
        &__contacts {
            @include tablet {
                display: none;
            }
            .footer {
                &__menu {
                    &-item {
                        font-size: 16px;
                        font-weight: 600;
                    }
                    &-link {
                        color: var(--c-gray-300);
                    }
                }
            }
            &-email,
            &-consult-btn {
                text-decoration: underline;
            }
        }

        &__bottom {
            color: var(--c-gray-200);
            font-size: 14px;

            @include tablet {
                font-size: 12px;
                line-height: 16px;

                .footer {
                    &__search-link,
                    &__langs {
                        display: none;
                    }
                }
            }

            a {
                color: var(--c-gray-400);
            }
            &-inner {
                padding: 36px 0;
                border-top: 1px solid var(--c-gray-700);

                @include tablet {
                    & > .row {
                        flex-wrap: nowrap;
                    }
                }
                @include mobile {
                    padding: 20px 0;
                    border-top: none;
                    > .row {
                        flex-wrap: wrap;
                    }
                }

            }
            &-col {
                margin-left: 8%;
                white-space: nowrap;

                @include mobile {
                    white-space: initial;
                    margin-left: 0;
                    margin-bottom: 10px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                &:first-child {
                    margin-left: 0;
                }

                &-left {
                    > .flex {
                        @include mobile {
                            flex-wrap: wrap;
                        }
                    }
                }
            }
        }

        &__langs {
            color: var(--c-gray-400);
            .icon {
                margin-right: 8px;
            }
            .dropdown__panel {
                top: auto;
                bottom: calc(100% + 10px);
                width: 100%;
                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 100%;
                    height: 10px;
                    width: 100%;
                    background: transparent;
                }
            }
        }

        @media (min-width: 768px) {
            .a-expand {
                &-body {
                    height: auto !important;
                    overflow: visible !important;
                }
                &-content {
                    display: block !important;
                }
            }
        }

        .cpr {
            @include tablet {
                &__text {
                    display: none;
                }
            }
        }

        .social {
            @include mobile {
                margin-top: 10px;
            }
        }
    }
    .social {
        list-style: none;
        display: flex;
        align-items: center;
        &__item {
            margin-left: 10px;
            &:first-child {
                margin-left: 0;
            }
        }
        &__link {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: var(--c-secondary-300);
            border-radius: var(--br-1);
            border: 1px solid var(--c-secondary-300);
            position: relative;
            overflow: hidden;

            @include tablet {
                width: 30px;
                height: 30px;
            }

            &::before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                mix-blend-mode: color-dodge;
                background: transparent;
                transition: all .3s ease;
            }
            &:hover {
                &::before {
                    background: var(--c-secondary-200);
                }
            }
        }
        &__icon {
            @include tablet {
                width: 13px;
            }
        }
        // &__icon {
        //     width: 13px;
        // }
    }
</style>
